
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, retry, Subject, Subscription, timeout } from 'rxjs';
import { LocalStorageService } from './local-storage.service';
import { LoginDataReflectService } from './login-data-reflect.service';
import { environment } from '../../environments/environment';
//import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class MainService {
  selectDistrict: any;
  subject = new Subject<any>();
  subject1 = new Subject<any>();
  selectBusiness: any;
  selectEventData: any;
  selectedSubEventData: any;
  apiToken: any;
  tabChangeDataGet: Subscription;
  private loginUrl = environment.anprUrl + 'login';
  private schoolUrl = environment.schoolURL;
  tempToken = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6MSwicm9sZSI6IkFkbWluIiwiaXBBZGRyZXNzIjoiOjoxIiwibG9naW5UeXBlIjoibW9iaWxlIiwiZXhwIjoxNjg3MjQyMDE5LCJpYXQiOjE2ODcyNDAyMTl9.QYhJWRlvBqUGd7dINIoYgQGmx-3Kq1jm-4NOREk79QE'

  constructor(
    public httpClient: HttpClient,
    private localStorageService: LocalStorageService,
    private loginDataReflect: LoginDataReflectService
  ) {
    this.tabChangeDataGet = this.loginDataReflect.sendData().subscribe(data => {
      this.apiToken = JSON.parse(localStorageService.getItem("loginData") || '{}').apitoken;
    });
    this.apiToken = JSON.parse(localStorageService.getItem("loginData") || '{}').apitoken;
  }

  // ---------------- get Api function -------------------- //
  getApi(endPointURL: any): Observable<any> {
    var httpHeaders = {
      headers: new HttpHeaders({
        'Authorization': `Bearer ${this.apiToken}`
      })
    }
    return this.httpClient.get(endPointURL, httpHeaders)
  }

  // // ---------------- post Api Function ------------------- //
  postApi(endPointURL: any, data: any, isHeader: any): Observable<any> {
    if (isHeader == 1) {
      var httpHeaders = {
        headers: new HttpHeaders({
          'Content-type': 'application/json',
          'Authorization': `Bearer ${this.apiToken}`
        })
      };
    } else {
      var httpHeaders = {
        headers: new HttpHeaders({
          'Content-type': 'application/json'
        })
      };
    }
    return this.httpClient.post(endPointURL, data, httpHeaders)
  }

  // ---------------- post Api form data Function ------------------- //
  postFormDataApi(endPointURL: any, data: any, isHeader: any): Observable<any> {
    if (isHeader == 1) {
      var httpHeaders = {
        headers: new HttpHeaders({
          'Content-Type': 'multipart/form-data',
        })
      };
      var tokenAPI = {
        headers: new HttpHeaders({
          'Authorization': `Bearer ${this.apiToken}`
        })
      }
      return this.httpClient.post(endPointURL, data, tokenAPI)
    } else {
      var httpHeaders = {
        headers: new HttpHeaders({
          'Content-Type': 'multipart/form-data',
          'Authorization': `Bearer ${this.apiToken}`
        })
      };
      return this.httpClient.post(endPointURL, data)
    }
  }

  // ---------------- put Api Function ------------------- //
  putApi(endPointURL: any, data: any, isHeader: any): Observable<any> {
    var httpHeaders = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this.apiToken}`
      })
    };
    return this.httpClient.put(endPointURL, data, httpHeaders)
  }

  // ---------------- Delete Api form data Function ------------------- //
  DeleteApi(endPointURL: any, data: any, isHeader: any): Observable<any> {
    var httpHeaders = {
      headers: new HttpHeaders({
        'Authorization': `Bearer ${this.apiToken}`
      })
    };
    return this.httpClient.delete(endPointURL, { ...httpHeaders, body: data })
  }

  getFilterData(data: any) {
    this.subject.next(data);
  }

  sendFilterData() {
    return this.subject.asObservable();
  }

  triggerProfileData(val?: number) {
    this.subject1.next(val);
  }

  setProfileData() {
    return this.subject1.asObservable();
  }
  login(email: string, password: string): Observable<any> {
    return this.httpClient.post<any>(this.loginUrl, { email, password });
  }


  recognizeImageData(sourceImage: string, captureImage: string): Observable<any> {
    
    const url = `${this.schoolUrl}/FaceRecognize/MatchFace`;

    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${this.tempToken}`
    });
  
    const body = {
      sourceImage: sourceImage,
      capturedImage: captureImage,
    };
    return this.httpClient.post<any>(url, body, { headers });
  }

  // In your main.service.ts
// recognizeImageData(sourceImage: string, captureImage: string): Observable<any> {
//   const url = `${this.schoolUrl}/Attendance/RecognizeImageData`;
//   const headers = new HttpHeaders({
//     'Content-Type': 'application/json',
//     'Authorization': `Bearer ${this.tempToken}`
//   });
//   const body = {
//     sourceImage: sourceImage,
//     capturedImage: captureImage,
//   };
  
//   // Add timeout and retry logic
//   return this.httpClient.post<any>(url, body, { headers })
//     .pipe(
//       timeout(30000), // 30 second timeout
//       retry(1) // Retry once if it fails
//     );
// }

}


